import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "countdown-timer__num" }

import {
	computed,
	onBeforeUnmount,
	onMounted,
	ref
} from "vue"

type Props = {
	seconds?: number
	size?: number
	color?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppCountdownTimer',
  props: {
    seconds: { default: 5 },
    size: { default: 32 },
    color: { default: '#979797' }
  },
  emits: ["finish"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const countdown = ref(props.seconds)
let tickTimer: ReturnType<typeof setInterval> | null = null
let finishTimer: ReturnType<typeof setTimeout> | null = null
let finished = false

const rootStyle = computed(() => ({
	'--cdt-duration': `${props.seconds}s`,
	'--cdt-size': `${props.size}px`,
	'--cdt-font-size': `${Math.round(props.size * 0.4)}px`,
	'--cdt-color': props.color
}))

const clearTimers = () => {
	if (tickTimer) {
		clearInterval(tickTimer)
		tickTimer = null
	}
	if (finishTimer) {
		clearTimeout(finishTimer)
		finishTimer = null
	}
}

const finish = () => {
	if (finished) {
		return
	}
	finished = true
	clearTimers()
	emit('finish')
}

onMounted(() => {
	tickTimer = setInterval(() => {
		countdown.value = Math.max(0, countdown.value - 1)
	}, 1000)
	finishTimer = setTimeout(finish, props.seconds * 1000)
})

onBeforeUnmount(clearTimers)

__expose({ flush: finish })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "countdown-timer",
    style: _normalizeStyle(rootStyle.value)
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("svg", {
      class: "countdown-timer__svg",
      viewBox: "0 0 20 20"
    }, [
      _createElementVNode("circle", {
        class: "countdown-timer__circle",
        cx: "10",
        cy: "10",
        r: "9"
      })
    ], -1)),
    _createElementVNode("span", _hoisted_1, _toDisplayString(countdown.value), 1)
  ], 4))
}
}

})